<template>
  <b-modal :id="modalId" :ref="modalId" centered hide-header-close no-close-on-backdrop no-close-on-esc
    content-class="tour-welcome-modal">
    <template #modal-header>
      <div class="w-100 d-flex justify-content-between align-items-center">
        <h3 class="header-title m-0 mx-auto text-center w-100">Boas-vindas ao seu Portal do Cooperado!</h3>
        <button type="button" aria-label="Close" class="close custom-close-icon" @click="onSkip">×</button>
      </div>
    </template>

    <div class="tour-modal-body">
      <p>
        Simplificamos o acesso aos seus serviços essenciais. Aqui você gerencia sua produção médica, acompanha
        solicitações
        em tempo real e atualiza seus dados com total segurança e autonomia.
      </p>

      <!-- Placeholder for the illustration -->
      <div class="illustration-container text-center my-4">
        <img src="../../assets/images/tour-home-page.svg" alt="Boas vindas"
          style="max-height: 250px; width: 100%; object-fit: contain;" />
      </div>

      <p class="font-weight-bold">
        Preparamos um tour guiado para você conhecer as principais funcionalidades e ganhar tempo no seu dia a dia.
      </p>
    </div>

    <template #modal-footer>
      <div class="w-100 d-flex justify-content-end align-items-center">
        <b-button class="btn-outline-custom-green mr-3" @click="onSkip">
          Explorar sozinho
        </b-button>
        <b-button class="btn-custom-green" @click="onStart">
          Iniciar tour
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "WelcomeTourModal",
  props: {
    modalId: {
      type: String,
      default: "welcome-tour-modal",
    },
  },
  methods: {
    onStart() {
      this.$emit("start-tour");
      this.$bvModal.hide(this.modalId);
    },
    onSkip() {
      this.$emit("skip-tour");
      this.$bvModal.hide(this.modalId);
    },
    show() {
      // O tour não é suportado em telas mobile (menu no modo hamburger)
      const BOOTSTRAP_LG = 992;
      if (window.innerWidth < BOOTSTRAP_LG) {
        this.$emit("skip-tour");
        return;
      }
      this.$bvModal.show(this.modalId);
    }
  },
};
</script>

<style lang="scss">
.tour-welcome-modal {
  .modal-dialog {
    max-width: 550px;
  }

  .modal-header {
    border-bottom: none;
    padding: 1.5rem 1.5rem 0.5rem;
    position: relative;

    .header-title {
      color: var(--dark-2);
      font-size: 2rem;
    }

    button.custom-close-icon {
      position: absolute;
      right: 1.5rem;
      top: 1.5rem;
      font-size: 2.3rem;
      line-height: 1;
      padding: 0;
      color: var(--dark-2);
      background: none;
      border: none;
      outline: none;
      margin-top: 2px;
    }
  }

  .tour-modal-body {
    margin-top: 20px;

    p {
      color: var(--dark-2);
      font-size: 1.6rem;
      line-height: 1.5;
    }

  }

  .modal-footer {
    border-top: 1px solid #e9ecef;
    padding: 1.25rem 2rem;
  }

  /* Custom buttons */
  .btn-outline-custom-green {
    background-color: transparent;
    color: #008b5e;
    border: 1px solid #008b5e;
    font-weight: 500;
  }

  .btn-outline-custom-green:hover {
    background-color: #008b5e;
    color: #ffffff;
  }

  .btn-custom-green {
    background-color: #008b5e;
    color: #ffffff;
    border: 1px solid #008b5e;
    font-weight: 500;
  }

  .btn-custom-green:hover {
    background-color: #006e4a;
    border-color: #006e4a;
  }
}

/* Overrides para os balões do Driver.js (Tour) */
.driver-popover {
  border-radius: 8px !important;
  padding: 20px !important;
  font-family: inherit !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15) !important;
  max-width: 450px !important;
}

.driver-popover-title {
  color: var(--dark-2, #3D3F40) !important;
  font-size: 1.8rem !important;
  font-weight: 500 !important;
  margin-bottom: 15px !important;
}

.driver-popover-description {
  color: var(--dark-2, #3D3F40) !important;
  font-size: 1.6rem !important;
  line-height: 1.5 !important;
  font-weight: 400 !important;
  white-space: pre-line !important;
}

.driver-popover-close-btn {
  color: var(--dark-2, #888) !important;
  font-size: 20px !important;
  font-weight: bold !important;
  top: 15px !important;
  right: 15px !important;
}

.driver-popover-footer {
  margin-top: 20px !important;
  padding-top: 15px !important;
  border-top: 1px solid #e9ecef !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

.driver-popover-progress-text {
  color: var(--dark-2, #6c757d) !important;
  font-size: 1.4rem !important;
  font-weight: 500 !important;
}

.driver-popover-footer button {
  padding: 6px 16px !important;
  font-size: 1.4rem !important;
  font-weight: 500 !important;
  border-radius: 4px !important;
  text-shadow: none !important;
  transition: all 0.2s !important;
}

.driver-popover-prev-btn {
  background-color: transparent !important;
  color: #008b5e !important;
  border: 1px solid #008b5e !important;
  margin-right: 10px !important;
}

.driver-popover-prev-btn:hover {
  background-color: #008b5e !important;
  color: #ffffff !important;
}

.driver-popover-next-btn {
  background-color: #008b5e !important;
  color: #ffffff !important;
  border: 1px solid #008b5e !important;
}

.driver-popover-next-btn:hover {
  background-color: #006e4a !important;
  border-color: #006e4a !important;
}

</style>
